import React from 'react';
import { Accordion, AccordionBody, AccordionItem, AccordionHeader, Text } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { getGATrackingAttrForSSR, useGATrackingForSSR } from '../../utils/gaTracking';
import Classes from './components/SellFaqList.scss';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

const SellFaqList = () => {
  const { t } = useI18nContext();
  useGATrackingForSSR();

  return (
    <>
      <div className={Classes.headingBlock}>
        <h2 className={Classes.heading}>{t('sell.page.faq.title')}</h2>
        <p className={Classes.subtitle}>{t('sell.page.faq.subtitle')}</p>
      </div>
      <article className={Classes.root}>
        <Accordion>
          {FAQ_KEYS.map((key) => (
            <AccordionItem
              key={key}
              className={Classes.item}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <AccordionHeader
                className={Classes.questionHeading}
                itemProp="name"
                {...getGATrackingAttrForSSR('Clicked', `SellFaqItem-${key}`)}
              >
                <Text.Large strong>{t(`sell.page.faq.${key}.question`)}</Text.Large>
              </AccordionHeader>
              <AccordionBody
                onClick={(event) => event.stopPropagation()}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div className="hz-Text hz-Text--bodyLarge" itemProp="text">
                  <p>{t(`sell.page.faq.${key}.answer`)}</p>
                </div>
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
      </article>
    </>
  );
};

export default SellFaqList;
